import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminAppBar from "../../components/adminComponents/AdminAppBar";
import TeamWise from "./TeamWise";
import AllLeads from "./AllLeads";
import { RiMenu5Fill } from "react-icons/ri";

import LeadDbService from "../Services/LeadDbService";
import {
  formatNumber,
  getIcons,
  getNumericValue,
  leadCharacterEmoji,
  leadStatusMap,
  teamIds,
  teamList,
  userId,
} from "../Constant/Constant";
import LeadDirectionModal from "./LeadDirectionModal";
import { showErrorToast, showWarningToast } from "../Constant/Notification";
import LeadTable from "../Form/LeadTable/LeadTable";
import LeadFilterSidebar from "./LeadReasignSection/LeadFilterSidebar";
import { getStatusBgColor, interestLevel, statusIcons } from "../../Enum";
import LocationService from "../Services/LocationService";
import teamService from "../Services/TeamService";
import Select, { components } from "react-select";
import { FaChevronDown } from "react-icons/fa";
import { ToastContainer } from "react-toastify";

const LeadDbMain = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedStatusId, setSelectedStatusId] = useState(null);
  const [isHover, setIsHover] = useState(false);
  const [leadCounts, setLeadCounts] = useState({
    unAssigned: 0,
    L0CTrn0qwWlHWvq2gXDm: 0,
    Auf9SQFhiKF7WRM9ZiTA: 0,
    gJxbL16EjFbzDFCoQU5G: 0,
    znvixWClH1PDoCXO4Aat: 0,
    "8337Bve50LqwfrkveUrY": 0,
    yUuWlPRZEosdOeLzyL0f: 0,
    VH26wB3VgVXBzoBJiqml: 0,
    PdCEXW0VIoVviuqvjdWc: 0,
  });

  const [filterVisible, setFilterVisible] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [interestLocationTags, setInterestedLocationTags] = useState([]);
  const [optionLocation, setOptionLocation] = useState([]);
  const [leadSources, setLeadSources] = useState([]);
  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startType, setStartType] = useState("text");
  const [endType, setEndType] = useState("text");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [leads, setLeads] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [nextPageToken, setNextPageToken] = useState(null);
  const [prevPageToken, setPrevPageToken] = useState(null);
  const [hasMoreLeads, setHasMoreLeads] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [leadCache, setLeadCache] = useState({});
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [visibleMenu, setVisibleMenu] = useState(false);
  const menuRef = useRef(null);

  const [lastFilterKey, setLastFilterKey] = useState(null);

  const status = [
    "Fresh",
    "Follow-up",
    "Dealing",
    "Registered Client",
    "Unanswered",
    "Not Interested",
    "Deal Lost",
    "Retry Suitable",
  ];

  console.log("Teams ", teamIds);
  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "transparent",
      border: "none",
      boxShadow: "none",
    }),
  };

  const getBackgroundClass = (label) => {
    switch (label.toLowerCase()) {
      case "gold":
        return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
      case "silver":
        return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
      case "bronze":
        return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
      case "diamond":
        return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
      default:
        return "text-black";
    }
  };

  const handleLeadInfo = (lead) => {
    console.log("Lead object:", lead);
    console.log("Lead ID:", lead.id);
    let path = "";
    if (userRole === "Admin") {
      path = `/admin/lead-info/${lead.id}`;
    } else if (userRole === "CMO") {
      path = `/cmo/lead-info/${lead.id}`;
    } else if (userRole === "MD") {
      path = `/md/lead-info/${lead.id}`;
    } else if (userRole === "BOD") {
      path = `/bod/lead-info/${lead.id}`;
    }
    navigate(path, { state: { lead } });
  };

  const columns = [
    {
      key: "name",
      title: "Name",
      render: (text, record) => (
        <div
          onClick={() => handleLeadInfo(record)}
          title={text.replace(/\b\w/g, (char) => char.toUpperCase())}
          className="text-blue-500 w-[160px] truncate cursor-pointer text-center"
        >
          {text.replace(/\b\w/g, (char) => char.toUpperCase())}
        </div>
      ),
    },
    {
      key: "phoneNumber",
      title: "Phone Number",
      render: (text, record) => (
        <div className="w-[160px] truncate text-center">
          +{record.countryCode} {record.phoneNumber}
        </div>
      ),
    },
    {
      key: "status",
      title: "Status",
      render: (value) => {
        const matchedStatus = statusIcons.find((item) => item.label === value);
        if (!matchedStatus)
          return <span className="text-gray-600 text-center w-full">Unknown</span>;
  
        return (
          <div
            className={`${getStatusBgColor(
              matchedStatus?.label
            )} flex items-center justify-center text-center w-44 px-2 gap-2 rounded-full`}
          >
            <img
              src={matchedStatus.image}
              alt={matchedStatus.label}
              className="w-5 h-5"
            />
            <span className="text-gray-700">{matchedStatus.label}</span>
          </div>
        );
      },
    },
    {
      key: "lastAct",
      title: "Last Act",
      render: (text) => {
        let bgColor = "";
        if (text <= 5) {
          bgColor =
            "border-[#98DDFF] border bg-blue-100";
        } else if (text <= 10) {
          bgColor =
            "border-[#FFA64D] border bg-orange-100";
        } else {
          bgColor =
            "border-[#EE6C4D] border bg-red-100";
        }
  
        const label = text > 1 ? "days" : "day";
        return (
          <span
            className={`${bgColor} text-gray-600 px-3 py-1 rounded-full flex items-center justify-center w-full`}
          >
            <div className="flex items-center gap-1">
              <div>{text}</div>
              <div>{label}</div>
            </div>
          </span>
        );
      },
    },
    {
      key: "character",
      title: "Character",
      render: (text) => {
        return (
          <div className="flex items-center justify-center">
            <img
              className="w-5"
              src={
                leadCharacterEmoji[text] || leadCharacterEmoji["Not Applicable"]
              }
              alt={text || "N/A"}
            />
          </div>
        );
      },
    },
    {
      key: "quality",
      title: "Lead Quality",
      render: (value) => {
        const matchedQuality = interestLevel.find(
          (item) => item.label === value
        );
  
        return (
          <div className="flex items-center justify-center gap-2 text-center">
            {matchedQuality?.label && (
              <>
              <img
              src={matchedQuality.image  }
              alt={matchedQuality.label}
              className="w-5 h-5"
            />
            <span className={`${getBackgroundClass(matchedQuality.label)}`}>
            {matchedQuality.label || "Not Quality"} 
          </span>
          </>
            )}
            
           
          </div>
        );
      },
    },
    {
      key: "location",
      title: "Location",
      render: (value) => {
        const firstLocation = value?.[0]?.name || "No Location";
        const extraCount = value?.length > 1 ? ` +${value.length - 1}` : "";
        const fullTitle = value?.map((loc) => loc.name).join(", ");
  
        return (
          <span
            className="inline-block cursor-pointer max-w-[170px] truncate whitespace-nowrap overflow-hidden text-center"
            title={fullTitle}
          >
            {firstLocation}
            <span className="text-blue-500">{extraCount}</span>
          </span>
        );
      },
    },
    {
      key: "teamName",
      title: "Team",
      render: (value) => {
        return (
          <div
            title={value}
            className="w-[100px] truncate cursor-pointer text-center"
          >
            {value}
          </div>
        );
      },
    },
    {
      key: "userName",
      title: "Assigned To",
      render: (value) => {
        return (
          <div
            title={value}
            className="w-[100px] truncate cursor-pointer text-center"
          >
            {value}
          </div>
        );
      },
    },
  ];
  

  const formatDate = (date) => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const formattedStartDate = startDate ? formatDate(startDate) : "";
  const formattedEndDate = endDate ? formatDate(endDate) : "";

  const applyFilter = () => {
    const newPageSize = 10;
    setLeadCache({});
    setCurrentPage(1);
    setLastFilterKey(null);
    getLead(null, "reset", newPageSize, 1, true);
  };

  const getLead = async (
    pageToken = null,
    direction = "next",
    limitOverride = null,
    overridePage = null,
    forceReload = false
  ) => {
    const targetPage = overridePage ?? currentPage;

    if (startDate && !endDate) {
      showErrorToast("End Date is required when Start Date is selected.");
      return;
    }

    const body = {
      searchKey: searchQuery || null,
      role: userRole || null,
      teamIds: Array.isArray(teamIds) ? teamIds : [],
      status: selectedStatus || null,
      quality: selectedLevel?.label || null,
      location: interestLocationTags?.value || null,
      filterTeamId: selectedTeam || null,
      user: selectedUser || null,
      startDate: formattedStartDate || null,
      endDate: formattedEndDate || null,
      limit: limitOverride ?? pageSize,
      next: direction === "next" ? pageToken : null,
      previous: direction === "previous" ? pageToken : null,
      direction,
    };

    if (!forceReload && leadCache[targetPage]) {
      console.log("Using cached leads for page:", targetPage);
      const cached = leadCache[targetPage];
      setLeads(cached.leads);
      setNextPageToken(cached.next);
      setPrevPageToken(cached.prev);
      setHasMoreLeads(!!cached.next);
      setCurrentPage(targetPage);
      return;
    }

    setLoading(true);

    try {
      const response = await LeadDbService.getLeadData(body);
      const newLeads = response.data.leads;
      const newNext = response.data.next;
      const newPrev = response.data.prev;

      setLeadCache((prev) => ({
        ...prev,
        [targetPage]: {
          leads: newLeads,
          next: newNext,
          prev: newPrev,
        },
      }));

      setLeads(newLeads);
      setNextPageToken(newNext);
      setPrevPageToken(newPrev);
      setHasMoreLeads(!!newNext);
      setCurrentPage(targetPage);
      setIsFilterApplied(true);
      setFilterVisible(false);
    } catch (error) {
      console.error("Error in getLead:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getLead(null, "reset", pageSize, 1, true);
  }, [pageSize]);



  const handleSearchLead = () => {
    setLeadCache({});
    setSearchKey(searchQuery);
    setCurrentPage(1);
    getLead(null, "reset", pageSize, 1, true);
  };

  const handlePageChange = (tokenOrValue, direction) => {
    console.log("Token or Value:", tokenOrValue);

    if (direction === "size") {
      const newPageSize = parseInt(tokenOrValue, 10);
      setPageSize(newPageSize);
      setCurrentPage(1);
      setLeadCache({});
      setNextPageToken(null);
      setPrevPageToken(null);

      getLead(null, "reset", newPageSize, 1);
    } else if (direction === "next") {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      getLead(nextPageToken, "next", pageSize, nextPage);
    } else if (direction === "previous") {
      const prevPage = Math.max(currentPage - 1, 1);
      setCurrentPage(prevPage);
      getLead(prevPageToken, "previous", pageSize, prevPage);
    }
  };

  const clearFilterData = () => {
    return new Promise((resolve) => {
      setSelectedStatus("");
      setSelectedLevel(null);
      getLead();
      setInterestedLocationTags([]);
      setSelectedTeam("");
      setSelectedUser("");
      setStartDate("");
      setEndDate("");
      setErrors({});
      resolve();
    });
  };

  const handleClearAndApplyFilter = async () => {
    await clearFilterData();
    applyFilter();
  };

  const handleSelectionChange = (selectedIds) => {
    setSelectedRows(selectedIds);
    console.log("All selected IDs:", selectedIds);
  };

  useEffect(() => {
    if (filterVisible) {
      (async () => {
        try {
          const responseLocation = await LocationService.fetchLocation();
          const dataLocation = responseLocation.data;
          const formattedLocations = Object.entries(dataLocation).map(
            ([name, id]) => ({
              value: id,
              label: name,
            })
          );

          setOptionLocation(formattedLocations);
        } catch (error) {
          console.error("Error fetching locations:", error);
        }

        try {
          const response = await teamService.fetchTeams();
          const data = response.data;
          const userData = JSON.parse(localStorage.getItem("userData"));
          const userRole = userData?.user?.role;
          const teamList = userData?.teamId || [];

          if (userRole === "Admin" || userRole === "CMO") {
            setTeams(data);
          } else if (userRole === "MD" || userRole === "BOD") {
            const list = teamList.map((team) => ({
              teamId: team.id,
              name: team.name,
            }));

            console.log("List of MD teams:", list);
            setTeams(list);
          }
        } catch (error) {
          console.error("Error fetching teams:", error);
        }
      })();
    }
  }, [filterVisible]);

  useEffect(() => {
    const fetchTeamUsers = async () => {
      if (!filterVisible || !selectedTeam) {
        setUsers([]);
        return;
      }

      setIsLoading(true);
      try {
        const response = await teamService.getTeamData(selectedTeam);
        const data = response.data;

        const combinedUsers = [
          ...(Array.isArray(data.BOD) && data.BOD.length > 0
            ? data.BOD.map((bod) => ({ name: bod.name, id: bod.id }))
            : []),
          ...(data.MD && data.MD.name !== null && data.MD.id !== null
            ? [{ name: data.MD.name, id: data.MD.id }]
            : []),
          ...(Array.isArray(data.members) && data.members.length > 0
            ? data.members.map((member) => ({
                name: member.name,
                id: member.id,
              }))
            : []),
        ];

        setUsers(combinedUsers.length > 0 ? combinedUsers : []);
      } catch (error) {
        console.error("Error fetching team users:", error);
        setUsers([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTeamUsers();
  }, [filterVisible, selectedTeam]);

  const handleFilterLeads = () => {
    setFilterVisible(true);
  };

  const handleStatusChange = (e) => {
    console.log(e);
    setSelectedStatus(e);
  };

  const handleSelectChange = (selectedOption) => {
    console.log(selectedOption);
    setSelectedLevel(selectedOption);
  };

  const handleLocationChange = (event) => {
    setInterestedLocationTags(event);
  };

  const handleTeamChange = (value) => {
    setSelectedTeam(value);
    setSelectedUser("");
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <FaChevronDown className="text-customGreen" />
      </components.DropdownIndicator>
    );
  };

  const getLocalDate = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60 * 1000);
    return localDate.toISOString().split("T")[0];
  };

  const handleReasignTeam = () => {
    navigate(`/admin/lead/reassign`, {
      state: {
        leadListArray: selectedRows,
        teamId: selectedTeam,
        memberId: selectedUser,
        leadCount: selectedRows.length,
      },
    });
  };

  console.log("Location ", interestLocationTags);

  const [leadDashBoardCount, setLeadDashBoardCount] = useState({
    allLeadCount: 0,
    assignedLeadCount: 0,
    unAssignedLeadCount: 0,
    freshLeadCount: 0,
    followUpLeadCount: 0,
    dealingLeadCount: 0,
    registeredClientLeadCount: 0,
    unAnsweredLeadCount: 0,
    notInterestedLeadCount: 0,
    dealLostLeadCount: 0,
    retrySuitableLeadCount: 0,

  });

  const [lastUpdateLeadData, setLastUpdateleadData] = useState();
  const [nextUpdateLeadData, setNextUpdateleadData] = useState();

  const icons = getIcons();

  const LeadDashboradCount = [
    {
      label: "All Leads",
      count: leadDashBoardCount?.allLeadCount || 0,
      bgColor: "bg-[#D3EEFF]",
      icon: icons?.AllLeadIcon,
    },
    {
      label: "Unassigned",
      count: leadDashBoardCount?.unAssignedLeadCount || 0,
      bgColor: "bg-[#EBEBFF]",
      icon: icons?.Unassigned,
    },
    {
      label: "Fresh Leads",
      count: leadDashBoardCount?.freshLeadCount || 0,
      bgColor: "bg-[#E3FFF5]",
      icon: icons?.Fresh,
    },
    {
      label: "Follow-Up",
      count: leadDashBoardCount?.followUpLeadCount || 0,
      bgColor: "bg-[#D2FAEC]",
      icon: icons?.FollowUp,
    },
    {
      label: "Dealing",
      count: leadDashBoardCount?.dealingLeadCount || 0,
      bgColor: "bg-[#9CE0C2]",
      icon: icons?.Dealing,
    },
    {
      label: "Registered Client",
      count: leadDashBoardCount?.registeredClientLeadCount || 0,
      bgColor: "bg-[#AEE4FF]",
      icon: icons?.RegisteredClient,
    },
    {
      label: "Unanswered",
      count: leadDashBoardCount?.unAnsweredLeadCount || 0,
      bgColor: "bg-[#FFCEC3]",
      icon: icons?.Unanswered,
    },
    {
      label: "Not Interested",
      count: leadDashBoardCount?.notInterestedLeadCount || 0,
      bgColor: "bg-[#FFBFA4]",
      icon: icons?.NotInterested,
    },
    {
      label: "Deal Lost",
      count: leadDashBoardCount?.dealLostLeadCount || 0,
      bgColor: "bg-[#FDB1B1]",
      icon: icons?.DealLost,
    },
    {
      label: "Retry Suitable",
      count: leadDashBoardCount?.retrySuitableLeadCount || 0,
      bgColor: "bg-[#FFFEDE]",
      icon: icons?.RetrySuitableIcons,
    },
  ];

  useEffect(() => {
    const fetchLeadDashBoardCount = async () => {
      let body = {};

      if (userRole === "Admin" || userRole === "CMO") {
        body = {
          teamId: [],
        };
      } else {
        body = {
          teamId: teamIds,
        };
      }
      try {
        const response = await LeadDbService.getLeadDadhBoardCount(body);
        console.log(response);
        const data = response.data;
        setLastUpdateleadData(data.lastUpdate.split(" ")[1] + " " + data.lastUpdate.split(" ")[2]);
        setNextUpdateleadData(data.nextUpdate.split(" ")[1] + " " + data.nextUpdate.split(" ")[2]);
        

        setLeadDashBoardCount({
          allLeadCount: data.allLeads,
          assignedLeadCount: data.allLeads - data.Unassigned,
          unAssignedLeadCount: data.Unassigned,
          freshLeadCount: data["Fresh"],
          followUpLeadCount: data["Follow-up"],
          dealingLeadCount: data["Dealing"],
          registeredClientLeadCount: data["Registered Client"],
          unAnsweredLeadCount: data["Unanswered"],
          notInterestedLeadCount: data["Not Interested"],
          dealLostLeadCount: data["Deal Lost"],
          retrySuitableLeadCount: data["Retry Suitable"],

        });
      } catch (error) {
        console.log(error);
      }
    };
    fetchLeadDashBoardCount();
  }, []);

  const handleNotInterestedLead = (statusId) => {
    console.log(statusId);

    if (userRole === "Admin") {
      navigate("/admin/reassign-lead", {
        state: { statusId, count: leadCounts["VH26wB3VgVXBzoBJiqml"] },
      });
    } else if (userRole === "CMO") {
      navigate("/cmo/reassign-lead", {
        state: { statusId, count: leadCounts["VH26wB3VgVXBzoBJiqml"] },
      });
    }
  };

  const handleRetrySuitableLead = (statusId) => {
    if (userRole === "Admin") {
      navigate("/admin/reassign-lead", {
        state: { statusId, count: leadCounts["PdCEXW0VIoVviuqvjdWc"] },
      });
    } else if (userRole === "CMO") {
      navigate("/cmo/reassign-lead", {
        state: { statusId, count: leadCounts["PdCEXW0VIoVviuqvjdWc"] },
      });
    }
  };

  const handleUnansweredLead = (statusId) => {
    if (userRole === "Admin") {
      navigate("/admin/reassign-lead", {
        state: { statusId, count: leadCounts["yUuWlPRZEosdOeLzyL0f"] },
      });
    } else if (userRole === "CMO") {
      navigate("/cmo/reassign-lead", {
        state: { statusId, count: leadCounts["yUuWlPRZEosdOeLzyL0f"] },
      });
    }
  };

  const handelFollowUpLead = (statusId) => {
    if (userRole === "Admin") {
      navigate("/admin/reassign-lead", {
        state: { statusId, count: leadCounts["Auf9SQFhiKF7WRM9ZiTA"] },
      });
    } else if (userRole === "CMO") {
      navigate("/cmo/reassign-lead", {
        state: { statusId, count: leadCounts["Auf9SQFhiKF7WRM9ZiTA"] },
      });
    }
  };

  const handleDealLostLead = (statusId) => {
    if (userRole === "Admin") {
      navigate("/admin/reassign-lead", {
        state: { statusId, count: leadCounts["8337Bve50LqwfrkveUrY"] },
      });
    } else if (userRole === "CMO") {
      navigate("/cmo/reassign-lead", {
        state: { statusId, count: leadCounts["8337Bve50LqwfrkveUrY"] },
      });
    }
  };

  const handleUnAssignedLead = (statusId) => {
    if (leadCounts.unAssigned != 0) {
      if (userRole === "Admin") {
        navigate("/admin/lead-unassign-lead", {
          state: {
            statusId,
            count: leadCounts["unAssigned"],
            teamStatus: true,
          },
        });
      } else if (userRole === "CMO") {
        navigate("/cmo/lead-unassign-lead", {
          state: { statusId, count: leadCounts["unAssigned"] },
        });
      }
    } else {
      showWarningToast("There no lead to assign");
    }
  };

  const handleFreshLead = (statusId) => {
    if (userRole === "Admin") {
      navigate("/admin/reassign-lead", {
        state: { statusId, count: leadCounts["L0CTrn0qwWlHWvq2gXDm"] },
      });
    } else if (userRole === "CMO") {
      navigate("/cmo/reassign-lead", {
        state: { statusId, count: leadCounts["L0CTrn0qwWlHWvq2gXDm"] },
      });
    }
  };

  const handleAddLead = () => {
    if (userRole === "Admin") {
      navigate("/admin/lead-upload");
    } else if (userRole === "CMO") {
      navigate("/cmo/lead-upload");
    }
  };

  const handleOpenModal = (statusId) => {
    console.log(statusId);
    setLeadCounts(leadDashBoardCount?.unAssignedLeadCount);
    setSelectedStatusId(statusId);
    setIsModalOpen(true);
  };

  const handleReAssignLead = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    console.log("Status ID:", selectedStatusId);

    setIsModalOpen(false);

    if (selectedOption === "view") {
      if (
        [
          "L0CTrn0qwWlHWvq2gXDm",
          "Auf9SQFhiKF7WRM9ZiTA",
          "gJxbL16EjFbzDFCoQU5G",
          "znvixWClH1PDoCXO4Aat",
          "8337Bve50LqwfrkveUrY",
          "yUuWlPRZEosdOeLzyL0f",
          "PdCEXW0VIoVviuqvjdWc",
        ].includes(selectedStatusId)
      ) {
        navigate(`/admin/lead/lead-filter`, {
          state: { id: selectedStatusId, leadCount: leadCounts },
        });
        console.log("Navigating with Status ID:", selectedStatusId);
      }
    } else if (selectedOption === "reassign") {
      if (userRole === "Admin" || userRole === "CMO") {
        switch (selectedStatusId) {
          case "VH26wB3VgVXBzoBJiqml":
            handleNotInterestedLead(selectedStatusId);
            break;
          case "PdCEXW0VIoVviuqvjdWc":
            handleRetrySuitableLead(selectedStatusId);
            break;
          case "yUuWlPRZEosdOeLzyL0f":
            handleUnansweredLead(selectedStatusId);
            break;
          case "8337Bve50LqwfrkveUrY":
            handleDealLostLead(selectedStatusId);
            break;
          case "L0CTrn0qwWlHWvq2gXDm":
            handleFreshLead(selectedStatusId);
            break;
          case "Auf9SQFhiKF7WRM9ZiTA":
            handelFollowUpLead(selectedStatusId);
            break;

          default:
            console.log("Unhandled Status ID:", selectedStatusId);
        }
      }
    } else if (selectedOption === "withTeam") {
      navigate("/admin/lead-unassign-lead", {
        state: {
          statusId: selectedStatusId,
          count: leadCounts["unAssigned"],
          teamStatus: true,
        },
      });
    } else if (selectedOption === "withoutTeam") {
      navigate("/admin/lead-unassign-lead", {
        state: {
          statusId: selectedStatusId,
          count: leadCounts["unAssigned"],
          teamStatus: false,
        },
      });
    }
  };

  console.log("Search Lead :", searchQuery);

  const handleAssignSummary = () => {
    navigate("/admin/lead-assign-summary");
  };
  const handleReassign = () => {
    navigate("/admin/lead-reasign-lead");
  };

  const handleMenuToggle = () => {
    setVisibleMenu(!visibleMenu);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setVisibleMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const MenuItem = ({ icon, label, count, onClick }) => (
    <div
      onClick={onClick}
      className="flex items-center gap-3 px-4 py-2 hover:bg-gray-100 cursor-pointer"
    >
      <img src={icon} className="h-5 w-5" />
      <span className="text-gray-800 hover:text-customGreen font-medium">
        {label}{" "}
        {count && <span className="text-sm text-gray-500">({count})</span>}
      </span>
    </div>
  );

  const Divider = () => <hr className="border-t border-gray-200 mx-4" />;

  return (
    <div className=" pt-24 bg-appGrayBackground ">
      <AdminAppBar />
      <ToastContainer />

      {/* Lead Data base */}

      <div className=" px-6 py-5   flex justify-between items-center">
        <div className="flex gap-3 items-center">
          <h1 className=" text-2xl xl:text-3xl text-slate-800 font-semibold ">
            Lead Database
          </h1>
          <div className="px-2 py-1 border text-xs text-blue-600 border-blue-600 bg-blue-100 rounded-full">Note: Last refreshed at {lastUpdateLeadData}. Next refresh at {nextUpdateLeadData}</div>
        </div>
        {/* {userRole === "MD" && (
          <div className=" flex items-center ">
            <label
              htmlFor="teamSelect"
              className="block w-72 text-xl font-medium"
            >
              Select Team:
            </label>
            <select
              id="teamSelect"
              value={selectedTeam}
              onChange={handleTeamChanges}
              className=" block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
              {teams.map((team) => (
                <option key={team.id} value={team.id}>
                  {team.name}
                </option>
              ))}
            </select>
          </div>
        )} */}

        {(userRole === "Admin" || userRole === "CMO") && (
          <div className="flex items-center gap-5">
            {/* <button
             
              className="w-[200px] xl:w-[202px] h-[45px] bg-customGreen text-white text-lg rounded-sm px-4 py-2"
            >
              Assigned Summary
            </button>

            <button
            
              className="w-[190px] xl:w-[202px] h-[45px] bg-customGreen text-white text-lg rounded-sm px-4 py-2"
            >
              Reassign
            </button>

            <button
             
              className="w-[190px] xl:w-[202px] h-[45px] border-2 border-customGreen text-customGreen text-lg rounded-sm px-4 py-2 "
            >
              +Add a New Lead
            </button> */}
            <div className="relative inline-block text-left" ref={menuRef}>
              <div
                onClick={handleMenuToggle}
                className="bg-white cursor-pointer w-[50px] h-[47px] rounded-xl flex items-center justify-center shadow"
              >
                <RiMenu5Fill className="text-customGreen text-3xl" />
              </div>

              {visibleMenu && (
                <div className="absolute right-0 mt-4 w-64 bg-white rounded-xl shadow-lg z-10 ">
                  <div className="absolute -top-2 rounded right-4 w-4 h-4 bg-white rotate-45"></div>

                  <div className="py-2">
                    <MenuItem
                      onClick={handleAddLead}
                      icon={icons.newLeadIcon}
                      label="Add a New Lead"
                    />
                    <Divider />
                    <MenuItem
                      icon={icons.Unassigned}
                      onClick={() => handleOpenModal("unAssigned")}
                      label="Unassign Lead"
                      count={leadDashBoardCount?.unAssignedLeadCount}
                    />
                    <Divider />
                    <MenuItem
                      onClick={handleAssignSummary}
                      icon={icons.assignSummaryIcon}
                      label="Assigned Summary"
                    />
                    <Divider />
                    <MenuItem
                      onClick={handleReassign}
                      icon={icons.reassignIcon}
                      label="Reassign"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Lead Dashboard Count */}

      <div className="grid grid-cols-4 mt-7 xl:grid-cols-6 gap-5 px-6">
        {LeadDashboradCount.map((item, index) => (
          <div key={index} className="w-full flip-card">
            <div className="flip-card-inner cursor-pointer rounded-2xl h-full min-h-[120px]">
              {/* Front side */}
              <div
                className={`${item?.bgColor} flip-card-front rounded-2xl p-4 h-full flex flex-col justify-between`}
              >
                <div className="text-2xl font-bold mb-2">
                  {formatNumber(getNumericValue(item?.count))}
                </div>
                <div className="flex items-center justify-between">
                  <div className="text-base font-semibold">{item?.label}</div>
                  <img
                    src={item?.icon}
                    alt="icon"
                    className="w-[30px] h-[30px]"
                  />
                </div>
              </div>

              {/* Back side */}
              <div
                className={`${item?.bgColor} flip-card-back rounded-2xl p-4 h-full flex items-center justify-center`}
              >
                <div className="flex flex-col items-center gap-[0.70rem] justify-between">
                  <img
                    src={item?.icon}
                    alt="icon"
                    className="w-[27px] mt-1  h-[27px]"
                  />
                  <div className="text-base font-semibold">{item?.label}</div>
                  <div className="text-xl text-center font-bold">
                  {(item?.count).toLocaleString('en-IN')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* {lead table } */}

      <div className="px-6 mt-11">
        <LeadTable
          data={leads}
          columns={columns}
          onPageChange={handlePageChange}
          selectedRows={selectedRows}
          onSelectionChange={handleSelectionChange}
          currentPage={currentPage}
          setSearchQuery={setSearchQuery}
          handleReasignTeam={handleReasignTeam}
          searchQuery={searchQuery}
          handleSearchLead={handleSearchLead}
          loading={loading}
          disPlay={false}
          pageSize={pageSize}
          nextPageToken={nextPageToken}
          prevPageToken={prevPageToken}
          hasMoreLeads={hasMoreLeads}
          handleFilterLeads={handleFilterLeads}
        />
      </div>

      <LeadFilterSidebar
        visible={filterVisible}
        onHide={() => setFilterVisible(false)}
        status={status}
        filterHide={false}
        selectedStatus={selectedStatus}
        handleStatusChange={handleStatusChange}
        interestLevel={interestLevel}
        selectedLevel={selectedLevel}
        handleSelectChange={handleSelectChange}
        optionLocation={optionLocation}
        interestLocationTags={interestLocationTags}
        handleLocationChange={handleLocationChange}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        customStyles={customStyles}
        getBackgroundClass={getBackgroundClass}
        teams={teams}
        selectedTeam={selectedTeam}
        DropdownIndicator={DropdownIndicator}
        handleTeamChange={handleTeamChange}
        errors={errors}
        users={users}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        isLoading={isLoading}
        startDate={startDate}
        setStartDate={setStartDate}
        startType={startType}
        setStartType={setStartType}
        endDate={endDate}
        setEndDate={setEndDate}
        endType={endType}
        setEndType={setEndType}
        getLocalDate={getLocalDate}
        handleApplyFilter={applyFilter}
        clearFilters={handleClearAndApplyFilter}
      />

      <div className="grid grid-cols-2  w-full mt-10 pb-8 px-20 xl:px-6 gap-16 xl:gap-5 custom-xl:gap-6">
        {/* <div className="w-full">
          <TeamWise selectedTeam={selectedTeam} />
        </div>
        <div className="w-full shadow-md rounded-md py-8 px-8 h-[800px] pb-6 bg-white">
          <AllLeads
            selectedTeam={selectedTeam}
            totalLeadCount={handleTotalLeadChange}
          />
        </div> */}
      </div>
      <LeadDirectionModal
        isOpen={isModalOpen}
        selectedStatusId={selectedStatusId}
        totalLead={leadDashBoardCount?.unAssignedLeadCount}
        onClose={() => setIsModalOpen(false)}
        onConfirm={handleReAssignLead}
      />
    </div>
  );
};

export default LeadDbMain;
